export const CACHE_TTL = 60 * 1000;
export const BASE_URL = process.env.REACT_APP_REST_URL;